import React, {Component} from "react";
import PropTypes from "prop-types";
import initialState from "../../../reducers/communications/initialState";
import {
    CLEAR_RECIPIENT_TYPE_SELECTION,
    SUBMIT_RECIPIENT_TYPE_SELECTION,
    submitNewCommunicationRecipientSelection,
    TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL
} from "../../../actions/communications/newCommunicationAction";
import { getMapOverlays, toggleMapOverlay } from "../../../actions/maps/mapOverlayAction";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import ContactsMap from "../ContactsMap/ContactsMap";
import {DefaultBtn} from "Ncontracts.Common.UI";
import NewCommunicationRecipientTypeSelector from "./NewCommunicationRecipientTypeSelector";
import SelectRecipientsFromListForm from "./SelectRecipientsFromListForm";
import isEmpty from "../../../helpers/isEmpty";
import SelectRecipientsByGroupForm from "./SelectRecipientsByGroupForm";
import _ from "lodash";
import { IconDropdownModel } from "../../../components/common/IconDropdown/_model";
import IconDropdown from "../../common/IconDropdown/IconDropdown";

class NewCommunicationAddRecipientsModal extends Component {

    static propTypes = {
        addRecipientsBy: PropTypes.string,
        mapOverlayOptions: PropTypes.arrayOf(PropTypes.shape(IconDropdownModel)),
        clearRecipientTypeSelection: PropTypes.func,
        history: PropTypes.object,
        submitNewCommunicationRecipientSelection: PropTypes.func,
        submitRecipientTypeSelection: PropTypes.func,
        toggleModal: PropTypes.func,
        getMapOverlayOptions: PropTypes.func,
        toggleMapOverlay: PropTypes.func,
        activeMapOverlayId: PropTypes.number
    };

    static defaultProps = { ...initialState };

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedRecipients: []
        };
        this.props.getMapOverlayOptions();
    }

    handleRecipientUpdate = updatedRecipients => {
        this.setState({...this.state, selectedRecipients: updatedRecipients});
    };

    getModalBody = () => {
        switch (this.props.addRecipientsBy) {
            case 'map':
                return <ContactsMap/>;

            case 'list':
                return <SelectRecipientsFromListForm selectedRecipients={this.state.selectedRecipients}
                                                     onRecipientUpdate={this.handleRecipientUpdate}/>;

            case 'group':
                return <SelectRecipientsByGroupForm onRecipientUpdate={this.handleRecipientUpdate}/>;

            default:
                return <NewCommunicationRecipientTypeSelector/>;
        }
    };

    getAddButton = () => {
        return <DefaultBtn className="btn--solid btn--smaller is-pulled-right"
                           disabled={isEmpty(this.state.selectedRecipients)}
                           onClick={() => this.handleAddClick()}>Add</DefaultBtn>;
    };

    handleAddClick = () => {
        this.props.submitNewCommunicationRecipientSelection(this.state.selectedRecipients);
        this.props.toggleModal();
    };

    getNextButton = () => {
        return <DefaultBtn className="btn--solid btn--smaller is-pulled-right"
                           onClick={() => this.props.submitRecipientTypeSelection()}>Next</DefaultBtn>;
    };

    getFooterText = () => {
        const {selectedRecipients} = this.state;
        const text = selectedRecipients.length ?
            <><span className="count">{selectedRecipients.length} </span>total Contacts selected</> :
            <>People in multiple groups will be added once.</>;

        return <div className="modal-footer-text">{text}</div>;
    };

    getModalFooter = () => {
        const {addRecipientsBy} = this.props;

        if (addRecipientsBy === 'map') return undefined; // ContactsMap has its own footer

        const nextOrAddButton = _.includes(['list', 'group'], addRecipientsBy) ? this.getAddButton() : this.getNextButton();
        const footerText = addRecipientsBy !== 'group' ? undefined : this.getFooterText();

        return (
            <footer className="modal-card-foot">
                {footerText}
                <div className="modal-footer-buttons">
                    <DefaultBtn className="btn--base btn--smaller is-pulled-right cancel-button"
                                onClick={() => this.cancelRecipientTypeSelection()}>
                        Cancel
                    </DefaultBtn>
                    {nextOrAddButton}
                </div>
            </footer>);
    };

    cancelRecipientTypeSelection = () => {
        this.props.clearRecipientTypeSelection();
        this.props.toggleModal();
    };

    toggleMapOverlay = (selectedOption) => {
        this.props.toggleMapOverlay(selectedOption.id);
    };

    render() {
        const { addRecipientsBy, mapOverlayOptions } = this.props;

        const modalTitleText = `Add Recipient(s)${addRecipientsBy === 'map' ? ' Map' : ''}`;
        const modalBody = this.getModalBody();
        const selectedOption = mapOverlayOptions.find(option => option.isSelected);
        const mapOverlayDropdown = addRecipientsBy == 'map'
            && <IconDropdown
                menuOptions={mapOverlayOptions}
                selectedOption={selectedOption}
                onChange={this.toggleMapOverlay}/>;

        const modalFooter = this.getModalFooter();

        return (
            <div className="modal is-active select-recipients-modal">
                <div className="modal-background"/>
                <div className="modal-card modal-content">
                    <header className="modal-card-head">
                        <div className="modal-card-title">
                            {modalTitleText}
                        </div>
                        {mapOverlayDropdown}
                    </header>
                    <section className="modal-card-body">
                        {modalBody}
                    </section>
                    {modalFooter}
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    addRecipientsBy: state.newCommunication.addRecipientsBy,
    mapOverlayOptions: state.mapOverlays.mapOverlayOptions
});

const mapDispatchToProps = dispatch => ({
    clearRecipientTypeSelection: (selectBy) => dispatch({type: CLEAR_RECIPIENT_TYPE_SELECTION, selectBy: selectBy}),
    submitNewCommunicationRecipientSelection: (selectedContacts) => dispatch(submitNewCommunicationRecipientSelection(selectedContacts)),
    submitRecipientTypeSelection: () => dispatch({type: SUBMIT_RECIPIENT_TYPE_SELECTION}),
    toggleModal: () => dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL}),
    getMapOverlayOptions: () => dispatch(getMapOverlays()),
    toggleMapOverlay: (activeMapOverlayId) => dispatch(toggleMapOverlay(activeMapOverlayId))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunicationAddRecipientsModal));
